import { localStorage } from '@fiverr-private/futile';
import { logger } from '@fiverr-private/obs';

export class ViewsCounter {
    constructor(storageKey, views = 0, createdDate = Date.now()) {
        this.storageKey = storageKey;
        this.views = views;
        this.createdDate = createdDate;
    }

    static getOrInit(storageKey, reset_ttl = null) {
        try {
            const viewsCounterObject = localStorage.get(storageKey);
            if (!viewsCounterObject) {
                return new ViewsCounter(storageKey);
            }

            const { views, createdDate } = viewsCounterObject;
            const viewsCounter = new ViewsCounter(storageKey, views, createdDate);

            if (!!reset_ttl && viewsCounter.isExpired(reset_ttl)) {
                viewsCounter.remove();

                return new ViewsCounter(storageKey);
            }

            return viewsCounter;
        } catch (error) {
            logger.error(`Failed getOrInit for storage key: ${storageKey} with error:${error}`);
        }
    }

    addView() {
        this.views++;
        this.set();
    }

    reached(viewCount) {
        return this.views >= viewCount;
    }

    set() {
        localStorage.set(this.storageKey, {views: this.views, createdDate: this.createdDate});
    }

    remove() {
        localStorage.remove(this.storageKey);
    }

    isExpired(ttl) {
        return (Date.now() - this.createdDate) > ttl;
    }
}
